import React, { useEffect } from 'react';
import { StyledEngineProvider } from '@mui/material/styles';
import { BrowserRouter } from 'react-router-dom';
import { SnackbarProvider } from 'notistack';
import { ThemeProvider } from '@mui/material/styles';
import { LocalizationProvider } from '@mui/x-date-pickers/LocalizationProvider'
import { AdapterDayjs } from '@mui/x-date-pickers/AdapterDayjs';
import GlobalStyles from '@mui/material/GlobalStyles';
import ScrollReset from 'src/components/ScrollReset';
import SessionCheck from 'src/components/SessionCheck';
import { AuthProvider } from 'src/contexts/Auth0Context';
import useSettings from 'src/hooks/useSettings';
import { createTheme } from 'src/theme';
import { renderRoutes } from 'src/routes';

const App = () => {
  const { settings } = useSettings();

  useEffect(() => {
    // Load Google Maps API if not already loaded
    if (!(typeof window.google === 'object' && typeof window.google.maps === 'object')) {
      const script = document.createElement('script');
      script.src = `https://maps.googleapis.com/maps/api/js?key=${process.env.REACT_APP_MAPS_API}&libraries=places&loading=async&v=weekly`;
      script.async = true;
      script.defer = true;
      document.head.appendChild(script);
    }
  }, []);

  const theme = createTheme({
    direction: settings.direction,
    responsiveFontSizes: settings.responsiveFontSizes,
    theme: settings.theme,
    language: settings.language
  });

  return (
    <StyledEngineProvider injectFirst>
      <ThemeProvider theme={theme}>
          <LocalizationProvider dateAdapter={AdapterDayjs}>
            <SnackbarProvider dense maxSnack={3} style={{ fontFamily: 'Roboto', fontSize: 14, fontWeight: 400 }}>
              <BrowserRouter>
                  <AuthProvider>
                    <GlobalStyles styles={{
                      '*': {
                        boxSizing: 'border-box',
                        margin: 0,
                        padding: 0,
                      },
                      html: {
                        WebkitFontSmoothing: 'antialiased',
                        MozOsxFontSmoothing: 'grayscale',
                        height: '100%',
                        width: '100%'
                      },
                      body: {
                        height: '100%',
                        width: '100%'
                      },
                      '#root': {
                        height: '100%',
                        width: '100%'
                      }
                    }} />
                    <ScrollReset />
                    <SessionCheck />
                    { renderRoutes() }
                  </AuthProvider>
              </BrowserRouter>
            </SnackbarProvider>
          </LocalizationProvider>
      </ThemeProvider>
    </StyledEngineProvider>
  );
};

export default App;
